import type { EcState as EcStateCookie } from '@empiriecom/mybuy-session/ApiKey';

type EcStateLoggedOut = {
  /** Logged in status */
  loggedIn: false;
};

type EcStateLoggedIn = {
  /** Logged in status */
  loggedIn: true;
  /** Bonusprogram status */
  bonusProgram: boolean;
  /** Customer's Credit affinity */
  creditAffinity: boolean;
};

export type EcState = EcStateLoggedOut | EcStateLoggedIn;

/**
 * Reads the ecState cookie and returns readable user state data
 *
 * @param cookies
 * @returns Object with ecState data (or empty object in case of invalid cookie)
 */
export const getEcState: (cookies: { [key: string]: string }) => EcState = ({ ecState }) => {
  if (!ecState) {
    return { loggedIn: false };
  }

  try {
    /*
      In the cookie is an encoded json object
      like "%7B%22li%22%3A%221%22%2C%22bop%22%3A%220%22%2C%22ca%22%3A%221%22%7D".
      So decode the string and parse to object.
    */
    const dataInCookie: EcStateCookie = JSON.parse(decodeURIComponent(ecState));

    if (dataInCookie.li !== '1') {
      return { loggedIn: false };
    }

    const { ca, bop } = dataInCookie;

    return {
      loggedIn: true,
      bonusProgram: bop === '1',
      creditAffinity: ca === '1',
    };
  } catch (err) {
    return { loggedIn: false };
  }
};
